import React from "react";
import './ReportModal.css';
import reportList from '../../../../../../assets/report-list.svg';
import close from '../../../../../../assets/close_small.svg';
import { Box, Table, TableCell, TableHeader, TableRow, TableBody, Text, Layer } from 'grommet';
import imageFile from '../../../../../../assets/photo.svg';
import { useStore } from "../../../../../../Hooks/useStore";
import { ReportNameEnum } from "../../../../../../util/report/ReportNameEnum";

const ReportModal = () => {
  const { rootStore } = useStore();

  const showImage = (src) => {
    rootStore.emsStore.handleHistoryReportImageState({imageUrl: src, showImage: true});
}

const getTimeWithInfo = (hourCount) => {
    if (hourCount > 12) {
        return "am";
    } else {
        return "pm"
    }
}

const getPrettyTime = (time) => {
    let timeParts = time.split(":");
    let hours = timeParts[0];
    let minutes = timeParts[1];
    let timeDesc = getTimeWithInfo(hours);
    return hours + ":" + minutes + " " + timeDesc;
}

const Reportname = (type) => {
    switch (type) {
        case ReportNameEnum.gm:
        return "Glucometer";

        case ReportNameEnum.aed:
        return "AED";

        case ReportNameEnum.bpm:
        return "Blood Pressure";

        case ReportNameEnum.po:
        return "Pulse Oximeter";

        default:
        return "";
    }
}
  
    return(
        <Layer className="layer-main">
            <Box className="report-view-modal">
                <div className="outer-wrapper">
                    <div className="main-wrapper">
                        <div className="title-wrapper">
                            <img width={20} src={reportList} alt="report list" />
                            <h3 className="modal-title">Medical Incidents {rootStore.emsStore.getEmergencyId} Report</h3>
                        </div>
                        <div className="wrapper" onClick={() => rootStore.emsStore.handleReportModal()}>
                            <img width={20} src={close} alt="report list" />
                            <h3 className="modal-close">Close</h3>
                        </div>
                    </div>
                </div>
                <Box className="report-modal-table-outer">
            <Table>
                <TableHeader className='table-header'>
                    <TableRow>
                        <TableCell scope="col">S.No.</TableCell>
                        <TableCell scope="col">Type</TableCell>
                        <TableCell scope="col">Time</TableCell>
                        <TableCell scope="col">File</TableCell>
                    </TableRow>
                </TableHeader>
                <TableBody className='table-body'>
                    {
                        rootStore.emsStore.getHistoryReportList.map((report, index) => {
                            return(
                                <TableRow>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{Reportname(report.imageType)}</TableCell>
                                    <TableCell>{getPrettyTime(report.formattedLastModified.split("T")[1])}</TableCell>
                                    <TableCell>
                                        <img onClick={() => showImage(report.imageUrl)} className='image-file-icon' src={imageFile} alt='image file icon' />
                                    </TableCell>
                                </TableRow>
                             )
                        })
                    }
                </TableBody>
            </Table>
            </Box>
            {/* <button className="export-report-button">Export entire report</button> */}
            </Box>
        </Layer>
    )
}

export default ReportModal;